export interface ChatUser {
  id: number;
  name: string;
  room_id: string | null;
  is_online?: boolean;
  unread_count?: number;
  profile_picture?: string;
}

export interface Company {
  company_id: string;
  company_name: string;
  user_type_id: number | null;
  user_type_name: string | null;
  users: ChatUser[];
}

export interface CompanyGroup {
  companies: Company[];
}

export interface ChatGroup {
  room_id: number;
  name: string;
  users: {
    id: number;
    name: string;
  }[];
}

export enum ChatScreenType {
  USER = "user",
  GROUP = "group",
  REPLIES = "replies",
  FINANCIAL_DOC = "financial_doc",
  LEGAL_DOC = "legal_doc",
}

export interface ChatScreenState {
  type: ChatScreenType;
  data: {
    user?: ChatUser;
    group?: ChatGroup;
    message?: any; // Add message type
    documentType?: "financial" | "legal";
    companyId?: string;
  };
}

export interface Message {
  id: number;
  user: {
    id: number;
    name: string;
    avatar?: string;
    profile?: string;
  };
  content: string;
  status?: string;
  metadata: {
    reads?: number;
    replies?: number;
    timestamp: string;
  };
  isCreated: boolean;
}

export interface ChatUser {
  id: number;
  name: string;
  room_id: string | null;
  is_online?: boolean;
}

export interface ChatGroup {
  room_id: number;
  name: string;
  unread_count?: number;
  users: {
    id: number;
    name: string;
  }[];
}

export enum ChatMessageListenerSource {
  CHAT_SCREEN = "chatScreen",
  CHAT_LISTING = "chatListing",
}

export interface UserStandaloneInfo {
  id: number;
  email: string;
  phone: string;
  name: string;
  user_type: {
    id: number;
    user_type: string;
  };
  profile_picture: string | null;
  is_staff: boolean;
  is_active: boolean;
  room_id: number;
  status: number;
  status_text: string;
  companies: {
    id: number;
    name: string;
    trading_as: string;
    commodity_types: {
      id: number;
      title: string;
    }[];
    administrative_first_name: string;
    administrative_last_name: string;
    administrative_email: string;
    administrative_contact_number: string;
    designation: string;
    facility_required: boolean;
    facility_amount: number | null;
    debtor_type: string | null;
    payment_terms: string | null;
    client_type: string | null;
    profession: string | null;
    reason_to_access: string;
  }[];
  message: string;
}
